import { useMemo } from 'react';
import { useAppSelector } from 'hooks';
import { selectIsBlocked } from 'store/settings/settings.selectors';

export const useLayoutScroll = (): {
  overflow: string;
  marginRight: number;
} => {
  const isBlocked = useAppSelector(selectIsBlocked);

  const overflow = useMemo(() => (isBlocked ? 'hidden' : 'auto'), [isBlocked]);

  const marginRight = useMemo(() => (isBlocked ? 3 : 0), [isBlocked]);

  return { overflow, marginRight };
};
